/* global dataLayer */
/* global $ */
// copied from community store
import { debug } from '../utils.js'
export default class AddToCart {
    constructor(el) {
        this.el = el
        this.el.addEventListener('click', this.addToCartAndGo)
    }

    addToCartAndGo = (e) => {
        this.ecommerceGTMCall(e.currentTarget)
        const pID = e.currentTarget.dataset.productId
        const type = e.currentTarget.dataset.addType

        let form
        let valid = true
        const priceInput = $(form).find(
            '.store-product-customer-price-entry-field',
        )

        if (type === 'modal') {
            form = $('#store-form-add-to-cart-modal-' + pID)
        } else if (type === 'list') {
            form = $('#store-form-add-to-cart-list-' + pID)
        } else {
            form = $('#store-form-add-to-cart-' + pID)
        }

        if (priceInput.length > 0) {
            const max = parseFloat(priceInput.attr('max'))
            const min = parseFloat(priceInput.attr('min'))
            const customerPrice = parseFloat(priceInput.val())

            if (
                customerPrice < min ||
                customerPrice > max ||
                !isFinite(customerPrice)
            ) {
                priceInput.focus()
                valid = false
            }
        }

        $(form)
            .find('input,textarea,select')
            .filter('[required]')
            .each(function (i, requiredField) {
                if ($(requiredField).val() === '') {
                    $(requiredField).focus()
                    valid = false
                }
            })

        if (!valid) {
            return false
        }

        const qtyField = $(form).find('.store-product-qty')
        const qty = qtyField.val()
        if (qty > 0) {
            const serial = $(form).serialize()
            window.communityStore.waiting()
            $.ajax({
                url: window.CARTURL + '/add' + window.TRAILINGSLASH,
                data: serial,
                type: 'post',
                cache: false,
                dataType: 'text',
                success: function () {
                    window.location.href = window.location.origin + '/cart'
                    return false
                },
            })
        } else {
            console.warn(window.QTYMESSAGE)
            qtyField.focus()
        }
    }

    ecommerceGTMCall = (el) => {
        const list = el.dataset.list
        const position = el.dataset.position
        const data = {
            event: 'productClick',
            ecommerce: {
                click: {
                    products: [
                        {
                            name: el.dataset.productName,
                            id: el.dataset.productSku,
                            price: el.dataset.productPrice,
                        },
                    ],
                },
            },
        }

        if (list) {
            data.ecommerce.click.actionField = { list: list }
        }

        if (position) {
            data.ecommerce.click.products[0].position = position
        }
        if (debug) {
            console.table(data.ecommerce.click.products)
        }
        dataLayer.push(data)
    }
}
